$(document).ready(function() {
    console.log("A11y2 start");

    // Accessibility attributes for navigation items
    $(".dropdown__family--grandchild .navlink.navlink--child span").attr({
        'role': 'heading',
        'aria-level': '2'
    });

    $(".dropdown__family--grandchild .navlink.navlink--child").attr({
        'role': 'presentation',
        'tabindex': '-1'
    });

    $('[data-hover-disclosure-toggle]')
        .on('mouseenter focus', function () {
            $(this).attr('aria-expanded', 'true');
        })
        .on('mouseleave blur', function () {
            $(this).attr('aria-expanded', 'false');
        });

    const pressText = $('.a11y-press-heading').text();
    $(".press-corousel").attr({'role':'region','aria-label':'In The Press'});

    $('[data-size-button]').on('click', function () {
        var $btn = $(this);
        var isExpanded = $btn.attr('aria-expanded') === 'false';
        $btn.attr('aria-expanded', isExpanded ? 'true' : 'false');
    });

    // Bundle product announcement
    setTimeout(() => {
        $(document).on('click', '.rebuy-button', function () {
            console.log("click bundle button");
            setTimeout(() => {
                const quantity = $('.rebuy-bundle-builder__group-container-header-products_count').text().trim();
                announce(`Items added to your bundle ${quantity} of 6`);
            }, 100);
            bundleIncDec();
        });
        bundleIncDec();

        // Reviews
        $('.okeReviews-review').each(function () {
            var $review = $(this);
            var reviewerText = $review.find('.okeReviews-review-reviewer-profile-name').text().trim();
            var $verifiedUser = $review.find('.okeReviews-review-reviewer-profile-status--verified');
            var verifiedText = $verifiedUser.length ? $verifiedUser.text() : '';

            $review.find('.okeReviews-review-helpful-vote-button--positive')
                .attr('aria-label', `Yes For ${reviewerText} ${verifiedText}`.trim());

            $review.find('.okeReviews-review-helpful-vote-button--negative')
                .attr('aria-label', `No For ${reviewerText}${verifiedText}`.trim());
        });
    }, 4000);

    function bundleIncDec() {
        $('.rebuy-bundle-builder__item-quantity-widget').each(function () {
            const $widget = $(this);
            const $buttons = $widget.find('.rebuy-bundle-builder__item-quantity-widget-button');

            $buttons.eq(0).on('click', function () {
                setTimeout(() => {
                    const quantity = $widget.find('.rebuy-bundle-builder__item-quantity-widget-label').text().trim();
                    announce(`Decreased by ${quantity}`);
                }, 100);
            });

            $buttons.eq(1).on('click', function () {
                setTimeout(() => {
                    const quantity = $widget.find('.rebuy-bundle-builder__item-quantity-widget-label').text().trim();
                    announce(`Increased by ${quantity}`);
                }, 100);
            });
        });
    }

    // Product Types roles
    $('.productTypes').attr('role','list');
    $('.productTypes > div').attr('role','listitem');

    // Navigation dropdown fix
    $('.menu__item.grandparent.kids-4.blocks-4 .header__dropdown__inner').removeAttr('class');
    $('.menu__item.grandparent.kids-4.blocks-4 .productTypes').addClass('header__dropdown__inner');
    $('.parent .navlink.navlink--toplevel').attr('aria-haspopup','true');
    $('.grandparent .navlink.navlink--toplevel').attr('aria-haspopup','true');

    $('#product-feature-subheading').attr('role','presentation');
    $('.product__block__text h6').attr('aria-level','2');
    $('.vip-title').attr('aria-level','3');
    $('.slideshow__wrapper').removeAttr('tabindex');

    $('.playPause').on('click', function() {
        const logo = $('.logo-bar__scale');
        const hasStyle = logo.is('[style]');
        if (hasStyle) {
        logo.removeAttr('style');
        $(this).find('i').removeClass('fa-pause').addClass('fa-play');
        $(this).attr('aria-label', 'Play logo animation');
    } else {
        logo.attr('style','--animation-duration:30s; --animation-time:31.296s;');
        $(this).find('i').removeClass('fa-play').addClass('fa-pause');
        $(this).attr('aria-label', 'Pause logo animation');
    }
    });

    // Stockist interaction
    setTimeout(() => {
        $('.stockist-result-name.stockist-feature-color').attr({'role':'button','tabindex':'0'});
        $(document).on('click keydown', '.stockist-result-name.stockist-feature-color', function(e) {
            if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
            e.stopPropagation();
            $(this).closest('.stockist-result.stockist-list-result').trigger('click');
            console.log('click');
        });
    }, 2000);

    // Media thumbnail keyboard support
    $('.media__thumb').on('keydown', function(e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            $(this).trigger('click');
        }
    });

    // Quantity control accessibility
    function toggleDecreaseButton($input) {
        var value = parseInt($input.val(), 10) || 0;
        var $decreaseBtn = $input.siblings('[data-decrease-quantity]');
        if (value <= 1) {
            $decreaseBtn.prop('disabled', true).attr('tabindex', '-1');
        } else {
            $decreaseBtn.prop('disabled', false).attr('tabindex', '0');
        }
    }

    $('[data-quantity-input]').each(function () {
        toggleDecreaseButton($(this));
    });

    $(document).on('input change', '[data-quantity-input]', function () {
        toggleDecreaseButton($(this));
    });

    $(document).on('click', '.quantity__button--plus', function () {
        var $input = $(this).siblings('[data-quantity-input]');
        setTimeout(() => {
            const Quantity = $input.val();
            announce(`Increase to ${Quantity}`);
            toggleDecreaseButton($input);
        }, 100);
    });

    $(document).on('click', '.quantity__button--minus', function () {
        var $input = $(this).siblings('[data-quantity-input]');
        setTimeout(() => {
            const Quantity = $input.val();
            announce(`Decrease to ${Quantity}`);
            toggleDecreaseButton($input);
        }, 100);
    });

    setTimeout(() => {
        $('.needsclick.klaviyo-sr-only.kl-private-reset-css-Xuajs1').removeClass('klaviyo-sr-only');
        $("div.menu__item").removeAttr("aria-expanded");

    }, 2000);

    $(".collection-list__nav-wrapper").each(function () {
        var $wrapper = $(this);
        var $scrollBox = $wrapper.find(".js-grid");
        var $prevBtn = $wrapper.find(".prev");
        var $nextBtn = $wrapper.find(".next");

        var scrollAmount = $scrollBox.outerWidth() * 0.8;

        $prevBtn.on("click", function () {
            $scrollBox.animate({ scrollLeft: $scrollBox.scrollLeft() - scrollAmount }, 100);
        });

        $nextBtn.on("click", function () {
            $scrollBox.animate({ scrollLeft: $scrollBox.scrollLeft() + scrollAmount }, 100);
        });
    });

    // Accessibility upgrade function (works for both bloop-button and bloop-social-item)
function enhanceCustomElements($elems) {
    $elems.each(function () {
        const $el = $(this);
        const text = $el.text().trim();

        $el.attr({
            'role': 'button',
            'tabindex': '0',
        });

        // Ensure keyboard accessibility
        $el.off('keydown.accessibility').on('keydown.accessibility', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).trigger('click');
            }
        });
    });
}

// Run once on existing elements
enhanceCustomElements($('bloop-button, bloop-social-item'));

// Watch for dynamically added elements
const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        $(mutation.addedNodes).each(function () {
            if (this.nodeType === 1) { // element node
                const $newEl = $(this);

                if ($newEl.is('bloop-button, bloop-social-item')) {
                    enhanceCustomElements($newEl);
                }

                // If wrapper contains bloop elements
                const $innerElems = $newEl.find('bloop-button, bloop-social-item');
                if ($innerElems.length) {
                    enhanceCustomElements($innerElems);
                }
            }
        });
    });
});

// Start observing the whole body
observer.observe(document.body, {
    childList: true,
    subtree: true
});


    console.log("A11y2 end");
});

document.addEventListener("DOMContentLoaded", function () {
  // =============================
  // Drawer Open / Close (jQuery)
  // =============================
  $(".header__mobile__button").on("click", function () {
    $(".drawer.header__drawer").parents().siblings().attr("aria-hidden", "true");
    $(".theme__header").attr("aria-hidden", "true");
     $('.smart-cart--enabled .drawer__content').show();
    setTimeout(() => {
      $(".drawer__button.drawer__close").focus();
    }, 500);
  });

  $(".drawer__button.drawer__close").on("click", function () {
    $(".drawer.header__drawer").parents().siblings().removeAttr("aria-hidden");
    $(".theme__header").removeAttr("aria-hidden", "true");
       $('.smart-cart--enabled .drawer__content').hide();
    setTimeout(() => {
      $(".header__mobile__button").focus();
    }, 500);
  });

  // =============================
  // Submenu Focus Management
  // =============================
  const sliderButtons = document.querySelectorAll("button.sliderow");

  sliderButtons.forEach(button => {
    button.addEventListener("click", function () {
      // Find the dropdown panel (next sibling)
      const nextDiv = this.nextElementSibling;

      if (nextDiv) {
        // Look for the drawer__button inside it
        const drawerBtn = nextDiv.querySelector("button.drawer__button");

        if (drawerBtn) {
          setTimeout(() => {
            drawerBtn.focus();
          }, 2000);
        }
      }
    });
  });
});
